var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMovie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.17,
    height: 31.17,
    viewBox: "0 0 31.17 31.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "movie",
    transform: "translate(-3902.048 -1913.976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1632",
    "data-name": "Path 1632",
    d: "M3933.218,1923.336v17.39a4.421,4.421,0,0,1-4.42,4.42h-22.33a4.421,4.421,0,0,1-4.42-4.42V1918.4a4.421,4.421,0,0,1,4.42-4.42h17.391Z",
    fill: "#e50019"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1191",
    "data-name": "Group 1191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1633",
    "data-name": "Path 1633",
    d: "M3915.4,1929.439c0-.9-.015-1.8.005-2.707.017-.776.511-1.069,1.164-.659q2.026,1.272,4.006,2.619a.825.825,0,0,1,0,1.486q-2,1.364-4.058,2.64c-.606.376-1.092.092-1.111-.616-.026-.921-.007-1.842-.007-2.763Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1189",
    "data-name": "Group 1189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1634",
    "data-name": "Path 1634",
    d: "M3916.416,1939.373v3.219h-4.121v-3.219Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1635",
    "data-name": "Path 1635",
    d: "M3923.5,1942.6h-4.1v-3.249h4.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1636",
    "data-name": "Path 1636",
    d: "M3909.326,1939.36v3.224h-2.921v-3.224Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1637",
    "data-name": "Path 1637",
    d: "M3929.4,1939.352v3.243h-2.9v-3.243Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1190",
    "data-name": "Group 1190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1638",
    "data-name": "Path 1638",
    d: "M3916.416,1916.29v3.219h-4.121v-3.219Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1639",
    "data-name": "Path 1639",
    d: "M3923.5,1919.52h-4.1v-3.248h4.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1640",
    "data-name": "Path 1640",
    d: "M3909.326,1916.277v3.223h-2.921v-3.223Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1641",
    "data-name": "Path 1641",
    d: "M3923.859,1918.916v-4.94l9.359,9.36h-4.94A4.421,4.421,0,0,1,3923.859,1918.916Z",
    fill: "#ef7982"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovie);
export default __webpack_public_path__ + "static/media/movie.8d0b8dfcb4d8dee6af7c53e12bf20907.svg";
export { ForwardRef as ReactComponent };